import { getAcceptLanguage, getTimezone } from "../utils/browser";
import { BASE, getCsrfToken } from "./constants";

export interface YandexRegisterUserInfo {
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  default_phone?: {
    number?: string;
  };
}

const getYandexRegisterUserInfo =
  async (): Promise<YandexRegisterUserInfo> => {
    const res = await fetch(`${BASE}/auth/register/userinfo`, {
      credentials: "same-origin",
    });
    if (res.ok) {
      return res.json();
    }
    throw new Error("user_absent");
  };

export type CompleteYandexRegistrationResponse =
  | { ok: true; redirect_uri?: string }
  | { ok: false };

const completeYandexRegistration = async (payload: {
  first_name?: string;
  last_name?: string;
  country?: string;
  phone?: string;
  agreed_to_newsletter: boolean;
  agreed_to_terms: boolean;
  lang: string;
}): Promise<CompleteYandexRegistrationResponse> => {
  const res = await fetch(`${BASE}/auth/register/external`, {
    method: "PUT",
    headers: {
      "Accept-Language": getAcceptLanguage(),
      "Content-Type": "application/json",
      "X-CSRFToken": getCsrfToken(),
    },
    body: JSON.stringify({
      ...payload,
      timezone: getTimezone(),
    }),
  });
  if (res.ok) {
    const data = await res.json().catch(() => ({}));
    return { ok: true, redirect_uri: data.redirect_uri };
  }
  return { ok: false };
};

export { completeYandexRegistration, getYandexRegisterUserInfo };
